export const CALENDAR_GRID_VIEW = {
  GRID_MONTH: 'dayGridMonth',
  GRID_WEEK: 'timeGridWeek',
  GRID_DAY: 'timeGridDay',
};

export const CALENDAR_MONTH = 'month';
export const CALENDAR_WEEK = 'week';
export const CALENDAR_DATE = 'date';
